import { createContext } from "react";

const MunicipalityContext = createContext([]);

export default MunicipalityContext;



// WEBPACK FOOTER //
// ./src/MunicipalityContext.js